const perusahaan = () => import(/* webpackPrefetch: true */ '@/views/private/master/perusahaan/index.vue')

const unit = () => import(/* webpackPrefetch: true */ '@/views/private/master/unit/index.vue')

const import_data = () => import(/* webpackPrefetch: true */ '@/views/private/master/import/index.vue')

const routes = [
  {
    path: "/master/perusahaan",
    name: "Perusahaan / OPD",
    component: perusahaan,
    meta: {
      title: "Perusahaan / OPD"
    }
  },

  {
    path: "/master/unit",
    name: "Unit",
    component: unit,
    meta: {
      title: "Unit"
    }
  },

  {
    path: "/master/import",
    name: "Import Data",
    component: import_data,
    meta: {
      title: "Import Data"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})